module.exports = __webpack_public_path__ + "static/android-chrome-512x512-5e1f9aebcf88466abd50dcc228f05c6d.png";